import Card from "components/card";
import DropzoneFile from "components/dropzone";
import React from "react";
import Button from "components/button/Button";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { usePapaParse } from "react-papaparse";
import ColumnsTable from "./components/ColumnsTable";
import { assignGoodsCSV } from "api/GoodsAPI";
import { IBranch } from "./types/branch.interface";
import { getBranch } from "api/BranchAPI";

const CSVAssignProductBranch: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const { readRemoteFile } = usePapaParse();
  const [files, setFiles] = React.useState<File[]>([]);
  const [parsedCSV, setParsedCSV] = React.useState<string[]>([]);
  const [importStatus, setImportStatus] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [branchDetail, setBranchDetail] = React.useState<IBranch>(null);

  const dropFile = (files: File[]) => {
    setFiles([...files]);
  };

  const removeFile = (files: File[]) => {
    setFiles([...files]);
  };

  const arrangeFiles = (files: File[]) => {
    setFiles([...files]);
  };

  const changeFile = (files: File[]) => {
    setFiles([...files]);
  };

  const getBranchDetail = (slug: string) => {
    const promise = getBranch(slug);
    promise
      .then((res) => {
        if (res.status === 200) {
          setBranchDetail(res.data?.data);
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Gagal mengambil data cabang!"
        );
      });
  };

  const onSubmit = async (
    e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    setIsLoading(true);

    if (files.length === 0) {
      toast("File CSV harus diimport!", { icon: "📂" });
      return;
    }

    if (!importStatus) {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        const path = reader.result;
        readRemoteFile(path.toString(), {
          header: true,
          download: true,
          delimiter: ";",
          skipEmptyLines: true,
          complete: (results) => {
            setParsedCSV(results.data as string[]);
            setImportStatus(true);
          },
        });

        setIsLoading(false);
      };
    } else {
      await assignGoodsCSV(branchDetail.id, files[0]).then((res) => {
        if (res.status === 201 || res.status === 200) {
          navigate(`/admin/branches/${slug}`);
          toast.success(res?.data?.message || "Barang berhasil diimport!");
        } else {
          toast.error(res?.data?.message || "Gagal mengimport barang!");
        }

        setIsLoading(false);
      });
    }
  };

  React.useEffect(() => {
    if (slug) getBranchDetail(slug);

    // eslint-disable-next-line
  }, []);

  return (
    <Card extra={"w-full h-full sm:overflow-auto px-6 pb-3"}>
      <header className="relative flex items-center justify-between pt-4">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          CSV Tambah Barang
        </div>
      </header>

      <form onSubmit={(e) => onSubmit(e)}>
        <div className="mt-8">
          <div className="flex flex-col">
            <label htmlFor="csv" className="label required">
              File CSV Barang
            </label>
            <DropzoneFile
              text="Template Barang CSV"
              accept={{
                "text/csv": [".csv"],
              }}
              maxSize={1024000}
              maxFiles={1}
              files={files}
              dropFile={(files: File[]) => dropFile(files)}
              removeFile={(files: File[]) => removeFile(files)}
              arrangeFiles={(files: File[]) => arrangeFiles(files)}
              changeFile={(files: File[]) => changeFile(files)}
            />
          </div>
          {parsedCSV.length > 0 && (
            <div>
              <p className="mb-3 ml-3 mt-7 font-medium text-gray-600">
                Detail Barang
              </p>
              <ColumnsTable tableData={parsedCSV} />
            </div>
          )}
        </div>
        {files.length > 0 && (
          <Button
            children={`${importStatus ? "Simpan" : "Preview Data"}`}
            size="fit"
            variant="primary"
            extra="mt-7 mb-5"
            disabled={isLoading || files.length === 0}
            isLoading={isLoading}
          />
        )}
      </form>
    </Card>
  );
};

export default CSVAssignProductBranch;
